import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ApiService from "../../services/ApiService";
import { toast } from "react-toastify";
import {formatDate} from "../../utils/helper";
import Paginator from "../../components/Paginator"; 


const MyTests = () => {
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({});
  const [apiData, setApiData] = useState({
        search: "",
        page: 1
    });

  useEffect(() => {
    fetchTests();
  }, [apiData.page,apiData.search]);
  
  const fetchTests = async () => {
    try {
        setLoading(true);
        const response = await await ApiService.request({
          method: 'GET',
          url: `getMyTests`, // Replace with your API endpoint
          params: apiData
        });
        const data = response.data;
        
        if (data && data.status === true) {
          setTests(data.data);
          setPagination(data.pagination);

        } else {
          toast.error(data.message );
        }
    } catch (err) {
      console.log("Failed to fetch interviews.");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (event) => {
    setApiData(prev => ({ ...prev, page: event }));
  };

  return (
    <div className="container mt-4 allTestsHeading">
      <div className="d-flex justify-content-between align-items-center rounded estate-search-bar mt-5">
        <h5 className="p-3 bg-white w-100">My Test Attempts</h5> 
      </div>

      <div className="bg-white p-4  mt-3">
          <div className="row">
            <div className="col-md-5 mb-3">
              <input type="search" name="search"  value={apiData.search} onChange={e => setApiData({ ...apiData, search: e.target.value })} className="form-control" placeholder="Search title..." />
            </div>
          </div>
        {loading ? (
          <div className="text-center">
            <span  className="spinner-border spinner-border-sm"
              role="status"  aria-hidden="true" ></span>
            <span className="sr-only mx-2">Loading...</span>
          </div>
            
        )  : (
          <div className="table-responsive tableOfTests">
            <table className="table table-bordered table-striped">
              <thead className="table-light">
                <tr>
                  <th>Test</th>
                  <th>Total Questions</th>
                  <th>Correct Answers</th>
                  <th>Status</th>
                  <th>Attempt at</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {tests.length > 0 ? tests.map((test, index) => (
                  <tr key={index}>
                    <td>{test.test.title}</td>
                    <td>{test.total_questions}</td>
                    <td>{test.correct_answers}</td>

                    <td>
                        <span className={test.status ==="Active"?"badge bg-primary":"badge bg-success"}  >
                            {test.status}
                        </span>
                        
                    </td>

                    <td>{formatDate(test.created_at,'DD MMM YYYY, hh:mm A')}</td>
                    <td>
                        { test.status ==="Active" &&
                              <Link to={`/test/${test.test_id}?attempt=${test.id}&question_id=${test?.last_question?.question_id || ''}&subset_id=${test?.last_question?.question?.section_id || ''}`} className="btn btn-base btn-sm m-2">Continue</Link>
                        }
                        { test.status ==="Completed" &&
                          <div>
                            <Link to={`/test/${test.test_id}?attempt=${test.id}&review=final`} className="btn btn-base btn-sm m-2">Report</Link>
                            <Link to={`/test/${test.test_id}`} className="btn btn-outline-base btn-sm m-2">Re-Attempt</Link>
                          </div>
                        }
                    </td>

                  
                  </tr>
                ))  : (
                  <tr>
                      <td colSpan="11" className="text-dark text-center mt-2">No Data Found!</td>
                  </tr>
                )}
              </tbody>
            </table>
            {pagination.total_pages > 1 && (
                  <Paginator
                      page={pagination.current_page}
                      rows={pagination.per_page}
                      totalRecords={pagination.total_records}
                      onPageChange={handlePageChange}
                  />
              )}
          </div>
        )}
      </div>
      
    </div>
  );
};

export default MyTests;
